define( 'templates/base-station-templates',['templates/template-builder'], function(TemplateBuilder) {
    var templateBuilder = new TemplateBuilder();
    
    return {
        /**
         * HEADERS -------------------------------------------------------
         */
        'headers' : {
            'comStateString' : templateBuilder.basicHeader('comStateString', 'Com'),
            'commissioningTime' : templateBuilder.basicHeader('commissioningTime', 'Commissioning Date'),
            'connectionType' : templateBuilder.basicHeader('connectionType', 'Primary connection'),
            'internetSubscription' : templateBuilder.basicHeader('internetSubscription', 'Connection priority'),
            'globalCoverage' : templateBuilder.basicHeader('globalCoverage', 'Coverage enabled'),
            'decommissioningTime' : templateBuilder.basicHeader('decommissioningTime', 'Decommissioning Date'), 
            'description' : templateBuilder.basicHeader('description', 'Description'),
            'dlkcf' : templateBuilder.basicHeader('dlkcf', 'Downlink central frequency'),
            'exploitationInfo' : templateBuilder.basicHeader('exploitationInfo', 'Exploitation info'),
            'hwversion' : templateBuilder.basicHeader('hwversion', 'Hardware version'),
            'siteHost' : templateBuilder.basicHeader('siteHost', 'Host'),
            'lifeCyclestatus' : templateBuilder.basicHeader('lifeCyclestatus', 'Lifecycle status'),
            'macroChannel' : templateBuilder.basicHeader('macroChannel', 'Macro channel'),
            'makerCode' : templateBuilder.basicHeader('makerCode', 'Maker code'),
            'muted' : templateBuilder.basicHeader('muted', 'Muted'),
            'nonCompliantActivity' : templateBuilder.basicHeader('nonCompliantActivity', 'Non compliant activity'),
            'operatingDays' : templateBuilder.basicHeader('operatingDays', 'Operating days'),
            'group' : templateBuilder.basicHeader('group', 'Operator'),
            'siteStatus' : templateBuilder.basicHeader('siteStatus', 'Site status'),
            'status' : templateBuilder.basicHeader('status', 'Built-in tests'),
            'versionUpgrade' : templateBuilder.basicHeader('versionUpgrade', 'Upgrade'),
            'versioncurrent' : templateBuilder.basicHeader('versioncurrent', 'Version'),
            'candidateExternalId' : templateBuilder.basicHeader('candidateExternalId', 'Site external ID'),
            'lessorId' : templateBuilder.basicHeader('lessorId', 'Site lessor ID'),
            'monarchBeaconEnabled' : templateBuilder.basicHeaderWithTitle('monarchBeaconEnabled', 'Monarch Beacon Enabled', ' When the feature is enabled, the station has the capacity to broadcast a beacon signal.'),
            'geolocGlobalStateOfContribution' : templateBuilder.basicHeader('geolocGlobalStateOfContribution', 'Contribution to geolocation'),

            // Sortable headers
            'id' : templateBuilder.sortableHeader('id', 'Id', 'id'),
            'lastDate' : templateBuilder.sortableHeader('lastDate', 'Last seen', 'last'),
            'site' : templateBuilder.sortableHeader('site', 'Site', 'simpleSite.nameCI')
        },

        /**
         * DATA TEMPLATES -------------------------------------------------------
         */

        'templates': {
            'comStateString' : templateBuilder.imgNode('/comState/${primarySecondaryComStateString}' , null, null, {'align':'center', 'title': '${primarySecondaryComStateString}'} ),
            'commissioningTime' : templateBuilder.basicNode( '${commissioningDate}' ),
            'connectionType' : {
                'nodeType':'td',
                'attributes':{'align':'center'},
                'content':
                    {
                    'nodeType':'span',
                    'data':{'is-conn-primary':'${primaryConnectionOk}','conn-type':'${primaryConnectionType}'},
                    'classes':['connectionType'],
                    'title':'${connStateString}'
                    }
            },
            'internetSubscription' : {
                'nodeType':'td',
                'attributes':{'align':'center'},
                'content':
                    {
                    'nodeType':'span',
                    'data':{'conn-type':'${siteConnectionPriority}'},
                    'classes':['connectionType'],
                    'title':'${siteConnectionPriorityString}'
                    }
            },
            'globalCoverage' : {
                'nodeType':'td',
                'content':
                    {
                    'attributes':{'align':'center'},
                    'nodeType':'switch_case',
                    'switchCaseField':'${globalCoverageEnable}',
                    'switchCase':
                        {
                        'true':
                            {
                            'nodeType':'span',
                            'classes':['icon-check','icon-large']
                            },
                        'false':
                            {
                            'nodeType':'span',
                            'classes':['icon-check-empty','icon-large']
                            }
                        }
                    }
            },
            'decommissioningTime' : templateBuilder.basicNode( '${decommissioningDate}' ),
            'description' : templateBuilder.basicNode( '${description}' ),
            'dlkcf' : templateBuilder.basicNode( '${dlkCf}' ),
            'exploitationInfo' : templateBuilder.basicNode( '${exploitationInfo}' ),
            'hwversion' : templateBuilder.basicNode( '${hwVersion}' ),
            'siteHost' : templateBuilder.linkNode( '${siteHostId}', '${siteHostName}'), 
            'id' : {
                'nodeType':'td',
                'content':
                    {
                    'nodeType':'a',
                    'data':{'hexid':'${hexId}','bsid':'${id}','site-name':'${site}'},
                    'href':'${url}',
                    'content':'${hexId}',
                    'classes':['id_link']
                    }
            },
            'lastDate' :  templateBuilder.basicNode( '${lastDate}' ),
            'lifeCyclestatus' :  templateBuilder.basicNode( '${lifeCycleStatus}' ),
            'macroChannel' :  templateBuilder.basicNode( '${macroChannel}' ),
            'makerCode' :  templateBuilder.basicNode( '${makerCode}' ),
            'muted' : templateBuilder.booleanNode( '${muted}' ),
            'nonCompliantActivity' : templateBuilder.booleanNode( '${nonCompliantActivity}' ),
            'operatingDays' : templateBuilder.basicNode( '${operatingDays}' ),
            'group' :  templateBuilder.linkNode( '${groupUrl}', '${groupName}'), 
            'site' : {
                'nodeType':'td',
                'content':
                    {
                    'data':{'site-name':'${site}','site-id':'${siteId}'},
                    'nodeType':'a',
                    'href':'${siteUrl}',
                    'content':'${site}',
                    'classes':['site_selector']
                    }
            },
            'siteStatus' :  templateBuilder.basicNode( '${siteStatus}' ),
            'status' : templateBuilder.imgNode( '/comState/${stateString}', null, null, {'align':'center', 'title': '${stateString}'} ),
            'versionUpgrade' : templateBuilder.basicNode( '${versionUpgrade}' ),
            'versioncurrent' : templateBuilder.basicNode( '${versionCurrent}' ),
            'candidateExternalId' : templateBuilder.linkNode( '${siteUrl}', '${candidateExternalId}'),
            'lessorId' :  templateBuilder.basicNode( '${lessorId}' ),
            'monarchBeaconEnabled' : templateBuilder.imgNode('/comState/${monarchBeaconEnabledString}' , null, null, {'align':'center', 'title': '${monarchBeaconEnabled}'} ),
            'geolocGlobalStateOfContribution' :  templateBuilder.imgNode( '/geolocStatus/${geolocGlobalStateOfContributionString}' , null, null, {'align':'center', 'title': '${geolocGlobalStateOfContribution}'} )
        }
    };
});
